import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./buttons.css";
import "./ConfirmDialog.css";

/**
 * Модальное подтверждение действия; rows — сводка [{ label, value, accent }].
 * text выводится над сводкой, note — под ней.
 */
function ConfirmDialog({
  isOpen,
  title,
  text,
  rows,
  note,
  confirmLabel,
  danger = false,
  themeClass,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onCancel();
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`rr-confirm-overlay ${themeClass || ""}`}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <div className="rr-confirm" role="alertdialog" aria-modal="true" aria-label={title}>
        <h3 className="rr-confirm__title">{title}</h3>
        {text && <p className="rr-confirm__text">{text}</p>}
        {rows?.length > 0 && (
          <dl className="rr-confirm__rows">
            {rows.map((row) => (
              <div key={row.label} className="rr-confirm__row">
                <dt>{row.label}</dt>
                <dd className={row.accent ? "is-accent" : undefined} title={row.value}>
                  {row.value}
                </dd>
              </div>
            ))}
          </dl>
        )}
        {note && <p className="rr-confirm__note">{note}</p>}
        <div className="rr-confirm__actions">
          <button type="button" className="rr-btn rr-btn--secondary" onClick={onCancel}>
            Отмена
          </button>
          <button
            type="button"
            className={`rr-btn ${danger ? "rr-btn--danger" : "rr-btn--primary"}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ConfirmDialog;
